import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.293 8.293A1 1 0 0 1 3 8h7V2H2v6.586l.293-.293ZM1 11V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3l-2 2Z"
    />
  </svg>
);
export default IconCommentStrokedSizeXs;
